export const MESSAGE_CODE_TO_LABEL_KEY = {
  1005: 'purchases.orders.alreadyinbag.message',
  1006: 'discount.code.not.valid',
  1007: 'discount.code.not.applicable',
  1008: 'discount.code.not.expired',
}

export const VOUCHERS_LOCATION = {
  checkout: 'checkout',
  cart: 'cart',
}
